module.exports = __webpack_public_path__ + "static/media/Illus-BowlFull@3x.b204c5d7.png";